export class DataEntryCustomFields { 
  public static readonly isRelieVRxChecked = 'Is RelieVRx checked?';
}
